<template>
    <div class="general">
        <div class="general-width">
            <GeneralHeader type="Vehicle" :title="vehicle.name || 'loading...'"
                :can_edit="user_perms.some(e => e.name == 'edit_vehicle')"
                :can_delete="user_perms.some(e => e.name == 'delete_vehicle')" @editModal="dialogEditVehicle = true"
                @deleteModal="dialogDeleteVehicle = true" />
            <v-skeleton-loader v-if="loading" type="card"></v-skeleton-loader>
            <VehicleInfo v-if="!loading" :vehicle="vehicle" :user_perms="user_perms" />
        </div>
    </div>

    <v-overlay v-model="dialogDeleteVehicle" location="top" style="justify-content:center;align-items: center;">
        <ConfirmForm :text="'Are you sure you wanna delete mission ' + vehicle.name + ' ?'" typeToDelete="Vehicle"
            @close="dialogDeleteVehicle = false" @confirm="deleteVehicle()"></ConfirmForm>
    </v-overlay>

    <v-overlay v-model="dialogEditVehicle" location="top" style="justify-content:center;align-items: center;">
        <EditVehicleForm :vehicle="vehicle" @close="dialogEditVehicle = false"></EditVehicleForm>
    </v-overlay>

</template>

<script setup>

import ConfirmForm from '@/components/admin/forms/ConfirmForm.vue';
import EditVehicleForm from '@/components/admin/forms/EditVehicleForm.vue';
import GeneralHeader from '@/components/admin/layouts/GeneralHeaderCard'
import VehicleInfo from '@/components/admin/vehicles/VehicleInfo.vue';
import router from '@/router';
import { useVehicleStore } from '@/store/vehicleStore';
import { storeToRefs } from 'pinia';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

const props = defineProps({
    user_perms: Object,
});


const loading = ref(true);
const vehicleStore = useVehicleStore();
const { vehicle } = storeToRefs(vehicleStore);
const route = useRoute();

const dialogEditVehicle = ref(false);
const dialogDeleteVehicle = ref(false);

onMounted(() => {
    vehicleStore.fetchVehicle(route.params.id).then(() => loading.value = false);
})


const deleteVehicle = async () => {
    loading.value = true;
    await vehicleStore.deleteVehicle(vehicle.value.id);
    dialogDeleteVehicle.value = false;
    loading.value = false;
    router.push("/");
}
</script>
